import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg, money } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Field, AccountSelect } from "@/components/FormBits";

export default function InternalForm({ data, onDone, defaultCard }) {
  const [from, setFrom] = useState("");
  const [to, setTo] = useState(defaultCard ? `card:${defaultCard}` : "");
  const [amount, setAmount] = useState("");
  const [memo, setMemo] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!from || !to) return toast.error("Choose both accounts");
    setBusy(true);
    const [kind, id] = to.split(":");
    try {
      await api.post("/transfers/internal", { from_account_id: from, amount: parseFloat(amount), memo, ...(kind === "card" ? { to_card_id: id } : { to_account_id: id }) });
      toast.success(`Transferred ${money(parseFloat(amount))}`);
      setAmount(""); setMemo(""); onDone();
    } catch (err) { toast.error(errMsg(err)); }
    setBusy(false);
  };

  return (
    <form onSubmit={submit} className="tile max-w-2xl" data-testid="internal-transfer-form">
      <div className="p-7 grid gap-5">
        <Field label="From"><AccountSelect accounts={data.accounts} value={from} onChange={setFrom} testid="internal-from-select" /></Field>
        <Field label="To">
          <Select value={to} onValueChange={setTo}>
            <SelectTrigger data-testid="internal-to-select"><SelectValue placeholder="Select destination" /></SelectTrigger>
            <SelectContent>
              {data.accounts.filter((a) => a.id !== from).map((a) => <SelectItem key={a.id} value={`acc:${a.id}`}>{a.name} ...{a.number_last4}</SelectItem>)}
              {data.cards.map((c) => <SelectItem key={c.id} value={`card:${c.id}`}>Pay {c.name} ...{c.number_last4} ({money(c.balance)} owed)</SelectItem>)}
            </SelectContent>
          </Select>
        </Field>
        <Field label="Amount"><Input type="number" step="0.01" min="0.01" value={amount} onChange={(e) => setAmount(e.target.value)} required data-testid="internal-amount-input" /></Field>
        <Field label="Memo (optional)"><Input value={memo} onChange={(e) => setMemo(e.target.value)} data-testid="internal-memo-input" /></Field>
        <Button disabled={busy} className="rounded-full bg-[var(--blue)] hover:bg-[var(--navy)] h-11" data-testid="internal-submit-button">{busy ? "Processing..." : "Transfer now"}</Button>
      </div>
    </form>
  );
}
